import { globalEnv } from "~/global-env";

/**
 * Format job type for display
 */
export const formatJobType = (jobType: string): string => {
  const formatted = jobType
    .replace("_", " ")
    .toLowerCase()
    .replace(/\b\w/g, (l: string) => l.toUpperCase());

  return formatted.replace(/\bCrm\b/g, "CRM").replace(/\bOpco\b/g, "OpCo");
};

/**
 * Format environment for display
 */
export const formatEnvironment = (environment: string): string => {
  return environment.charAt(0).toUpperCase() + environment.slice(1);
};

/**
 * Format timestamp to UTC string
 */
export const formatTimestamp = (timestamp: string): string => {
  return new Date(Number(timestamp) * 1000).toUTCString().replace("GMT", "UTC");
};

/**
 * Normalize substate for URL generation
 * Maps certain substates to their base states for consistent URL routing
 */
const normalizeSubstateForUrl = (substate: string | null): string => {
  if (!substate) return "";

  const substateMapping: Record<string, string> = {
    DATA_VALIDATION_QUEUED: "DATA_VALIDATION",
  };

  const normalizedSubstate = substateMapping[substate] || substate;
  return normalizedSubstate.toLowerCase().replace(/_/g, "-");
};

/**
 * Build CRM Import page URL
 */
export const buildCrmImportUrl = (
  jobType: string,
  substate: string | null,
  jobId: string,
  createdAt: string,
): string => {
  const baseUrl = window.location.origin;
  const jobTypeLower = jobType.toLowerCase().replace(/_/g, "-");
  const substateLower = normalizeSubstateForUrl(substate);

  return `${baseUrl}/canopy${globalEnv.dataStudioRoute}/${jobTypeLower}/${substateLower}?Id=${jobId}&created=${createdAt}`;
};
